import React from 'react'
import { useVehicle } from 'contexts'

const VehicleSheetEquipments = () => {
  const { equipments } = useVehicle()

  return (
    <section className="vehicle-sheet-card vehicle-sheet__equipments">
      <h2 className="vehicle-sheet__subsection-title">Équipements</h2>
      {equipments.length > 0 ? (
        <ul className="vehicle-sheet__equipment-list">
          {equipments.map((equipment) => (
            <li key={equipment.name}>{equipment.name}</li>
          ))}
        </ul>
      ) : (
        <p className="vehicle-sheet__empty-state">Aucun équipement renseigné</p>
      )}
    </section>
  )
}

export default VehicleSheetEquipments
